module.exports = __webpack_public_path__ + "static/media/oberflex-zebranot13-2560x1440.e8965214.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-zebranot13-2560x1440.jpg
// module id = 1067
// module chunks = 37